import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { PrimeNGConfig, Translation } from 'primeng/api';

import { CoreDataService } from './shared/services/core-data.service';
import { FlxAppVersionCheckerService, FlxMenuV2Service } from "@fluxys/gsmart";
import { ListPermissionsResponse } from './shared/api/clients';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'connect-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly appVersionCheckerService = inject(FlxAppVersionCheckerService);
  private readonly translocoService = inject(TranslocoService);
  private readonly primeNgConfig = inject(PrimeNGConfig);
  private readonly coreDataService = inject(CoreDataService);

  private readonly destroyRef = inject(DestroyRef);
  private readonly menuService = inject(FlxMenuV2Service);

  constructor() {
      this.menuService.onCommand$.pipe(takeUntilDestroyed()).subscribe((command) => {
      alert(`Menu command executed: ${command}`);
    });
  }

  ngOnInit(): void {
    this.translocoService
      .selectTranslate<string>('app.title')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((appTitle) => this.appVersionCheckerService.updateAppName(appTitle));
    this.translocoService
      .selectTranslateObject<Translation>('primeng')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((translations) => this.primeNgConfig.setTranslation(translations));

    this.listPermissionsData();
  }

  listPermissionsData(): void {
    this.coreDataService.listPermissions().subscribe((listPermissionsResponse: ListPermissionsResponse) => {
      if (!listPermissionsResponse) {
        return;
      }
    });
  }
}
